export const KEY_CODES = {
	ESCAPE: 'Escape',
	ENTER: 'Enter',
};
